import { Flex } from '@chakra-ui/react';
import KycRfiSection from 'components/KycRfi/KycRfiSection';

const KycRfiDetails = ({
  kycDetails,
  documentInfo,
  entityId,
  parentId,
  fetchKycDetails,
  rfiTemplates,
  resourceType,
  rfiTagTypes,
  rfiTagSubtypes,
}) => {
  return (
    <Flex direction='row' alignContent={'center'} justifyContent={'center'} gap={4} width='100%' height='100%' mt={8}>
      <KycRfiSection
        title="Requested RFI's"
        rfiList={kycDetails?.rfi_requested}
        emptyMessage="No RFI Request's available"
        documentInfo={documentInfo}
        entityId={entityId}
        parentId={parentId}
        submittedRfiList={kycDetails?.rfi_submitted}
        rfiTemplates={rfiTemplates}
        fetchKycDetails={fetchKycDetails}
        resourceType={resourceType}
        rfiTagTypes={rfiTagTypes}
        rfiTagSubtypes={rfiTagSubtypes}
      />

      <KycRfiSection
        title="Submitted RFI's"
        isSubmittedRfi
        rfiList={kycDetails?.rfi_submitted}
        emptyMessage="No RFI Submission's available"
        fetchKycDetails={fetchKycDetails}
        documentInfo={documentInfo}
        entityId={entityId}
        requestedRfiList={kycDetails?.rfi_requested}
        submittedRfiList={kycDetails?.rfi_submitted}
        rfiTemplates={rfiTemplates}
        resourceType={resourceType}
        rfiTagTypes={rfiTagTypes}
        rfiTagSubtypes={rfiTagSubtypes}
      />
    </Flex>
  );
};

export default KycRfiDetails;
